import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { zodOptionalId } from 'routes/routeUtils';
import { z } from 'zod';

export const pharmacyClaimNewRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/claims/new-claim',
  validateSearch: z.object({
    labId: zodOptionalId,
    initiateExternalDocumentId: z.string().optional(),
    initiateExternalDocumentSignedId: z.string().optional(),
    initiateExternalDocumentOrigin: z.enum(['digipharmacie', 'real_invoice']).optional(),
    initiateExternalDocumentUrl: z.string().optional(),
    initiateMessage: z.string().optional(),
    compensationId: zodOptionalId,
  }),
}).lazy(() =>
  import('pages/pharmacy/Cases/Claims/PharmacyClaimNewPage/PharmacyClaimNewPage').then(
    (d) => d.Route
  )
);
